import { render } from "./yc-qlc.vue?vue&type=template&id=68ddd3c1&scoped=true"
import script from "./yc-qlc.vue?vue&type=script&lang=js"
export * from "./yc-qlc.vue?vue&type=script&lang=js"

import "./yc-qlc.vue?vue&type=style&index=0&id=68ddd3c1&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ddd3c1"]])

export default __exports__